import { ENV } from '@/shared/config';

import { getAccessToken } from './client';

export function getHostageChatUrl(userId: string): string {
  return `${ENV.apiBaseUrl}/greenfield/care/${userId}/hostage/chat`;
}

export async function createLotusAuthHeadersOptional(): Promise<Record<string, string>> {
  const token = await getAccessToken();
  return token ? { Authorization: `Bearer firebase:${token}` } : {};
}
